/**
 * just bounce them to the homepage for the moment when they hit invalid page
 */
import { NextLink } from "../components/Links";
import { FaceFrownIcon } from "@heroicons/react/24/outline";

export const NotFoundPage = () => {
  return (
    <div className="mx-10 mt-40">
      <div className="text-lg">
        <FaceFrownIcon className="h-20 w-20 text-gray-300" />
        <div className="my-8 text-xl text-red-400">404 ERROR</div>
        <h1 className="mb-8 text-4xl">
          We couldn&apos;t find the page you were looking for.
        </h1>
        <div className="mb-4 tracking-wide text-gray-500">
          You may have mistyped the address or the page was moved or deleted.
        </div>
        <div className="tracking-wide text-gray-500">
          You can search for more results or head to our{" "}
          <NextLink href="/" className="text-blue-500">
            homepage
          </NextLink>
          .
        </div>
      </div>
    </div>
  );
};
